export default __webpack_public_path__ + "static/ayline-8d8eae620cf371c406e40e8e13506321.jpg";